import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'audicio.activeAuditId';
const ActiveAuditContext = createContext(null);

export function ActiveAuditProvider({ children }) {
  const [activeAuditId, setActiveAuditIdState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || null; } catch { return null; }
  });

  const setActiveAuditId = useCallback((id) => {
    setActiveAuditIdState(id || null);
    try {
      if (id) localStorage.setItem(STORAGE_KEY, id);
      else localStorage.removeItem(STORAGE_KEY);
    } catch { /* localStorage unavailable */ }
  }, []);

  return (
    <ActiveAuditContext.Provider value={{ activeAuditId, setActiveAuditId }}>
      {children}
    </ActiveAuditContext.Provider>
  );
}

export function useActiveAudit() {
  const ctx = useContext(ActiveAuditContext);
  if (!ctx) throw new Error('useActiveAudit must be used within an ActiveAuditProvider');
  return ctx;
}
